@if (!callTime) {
  <div class="availability">
    <span class="availability-label">Availabilities</span>
    @if (timezoneName) {
      <ul class="availability-list">
        @if (requestedAnotherTime) {
          <li>
            <app-pill color="warning" shape="square" size="md" icon="warning">New date requested</app-pill>
          </li>
        }
        @for (availability of slots.slice(0, requestedAnotherTime ? 1 : 2); track availability) {
          <li>
            <app-pill
              shape="square"
              size="md"
              [title]="moment(availability.start).tz(timezoneName).format('ddd Do MMM LT (z)')"
            >
              {{ moment(availability.start).tz(timezoneName).format('ddd Do MMM LT (z)') }}
            </app-pill>
          </li>
        }
        @if (slots.length > (requestedAnotherTime ? 1 : 2)) {
          <li class="ellipse-box">
            <span>...</span>
            <div class="drop-down">
              @for (availability of slots.slice(2); track availability) {
                <div class="drop-down-item flex">
                  <app-pill shape="square" size="md">
                    {{ moment(availability.start).tz(timezoneName).format('ddd Do MMM LT (z)') }}
                  </app-pill>
                </div>
              }
            </div>
          </li>
        }
      </ul>
    }
    @if (!timezoneName) {
      <p>Please assign a country and a timezone to this expert</p>
    }
  </div>
} @else {
  <div class="availability">
    <span class="availability-label">Requested Call Time</span>
    <app-pill
      shape="square"
      size="md"
      color="tertiary"
      [title]="
        timezoneName
          ? moment(callTime).tz(timezoneName).format('ddd Do MMM LT (z)')
          : moment(callTime).tz('UTC').format('ddd Do MMM LT (z)')
      "
    >
      @if (timezoneName) {
        {{ moment(callTime).tz(timezoneName).format('ddd Do MMM LT (z)') }}
      } @else {
        {{ moment(callTime).tz('UTC').format('ddd Do MMM LT (z)') }}
      }
    </app-pill>
  </div>
}
